export default __webpack_public_path__ + "static/media/star-full.94ae782b.svg";